import initializeSwiper from './swiper-utils.js';
import { initLookBook24 } from './components/lookbook.js';
import { swiperCampaign24 } from './components/campaign.js';
import runCartDrawerUpsell from './components/cartUpsell.js';
import { updateNumberCartCount } from './components/navbar.js';
import { productVariantSwatchesPrices } from './components/plp';
import { initSitelock } from './components/sitelock';

// cart drawer upsell
runCartDrawerUpsell();

// swipers
initializeSwiper();
swiperCampaign24();

const handleSelectColor = (e) => {

  const selectedColor = e.target.dataset.color;
  const product = e.target.dataset.product;

  showColorImages(product, selectedColor, e);
  showSizesFromSelectedColor(product, selectedColor);
  if (e.target.hasAttribute('data-direct-atc')) {
    const variant = e.target.dataset.variant;
    const availability = e.target.dataset.variantAvailability;
    changeATCVariantId(variant, availability, product)
  };
  if (e.target.hasAttribute('data-gift-card')) {
    productVariantSwatchesPrices(e.target)
  }
};

const handleSelectColorLink = (e) => {
  e.preventDefault();
  const target = e.currentTarget;
  const selectedColor = target.dataset.color;
  const product = target.dataset.product;

  showColorImages(product, selectedColor, e);
  // `#fieldset-{product.id}` is duplicated (origin + test blocks share the same id),
  // so document.querySelector("#fieldset-" + product) inside showColorImages can grab
  // the wrong (hidden) one. Scope the active-swatch toggle to this link's own fieldset.
  target
    .closest('fieldset')
    ?.querySelector('.variant-color-img.active')
    ?.classList.remove('active');
  target.querySelector('.variant-color-img')?.classList.add('active');
  showSizesFromSelectedColor(product, selectedColor);
};

const showColorImages = (product, color, e) => {
  const productCard = e.currentTarget.closest(".product-card");
  const mediaContainer = productCard.querySelector(`#media-container-${product}`);
  const mediaColorContainer = mediaContainer.querySelector(
    "#image-container-" + color
  );
  const fieldsetContainer = document.querySelector("#fieldset-" + product);
  fieldsetContainer
    .querySelector(".variant-color-img.active")
    ?.classList.remove("active");
  mediaContainer
    .querySelectorAll(".image-container")
    .forEach((el) => (el.style.display = "none"));
  mediaColorContainer.querySelectorAll("img").forEach((imagen) => {
    imagen.removeAttribute("style");
  });
  mediaColorContainer.style.display = "block";
};

const showSizesFromSelectedColor = (product, selectedColor) => {
  const sizes = document.querySelectorAll(`[data-product-id='${product}']`);
  for (let i = 0; i < sizes.length; i++) {
    const currentVariant = sizes[i];

    if (currentVariant.attributes['data-color'].value == selectedColor) {
      currentVariant.style.display = 'block'
    } else {
      currentVariant.style.display = 'none'
    }
  }
}

const changeATCVariantId = (variant, availability, product) => {
  const atcButton = document.querySelector(`a[data-product='${product}']`);
  atcButton.href = `/cart/add?id=${variant}&quantity=1`
  atcButton.setAttribute('data-variant-id', variant);
  if (availability == 'false') { atcButton.setAttribute('disabled', true) } else { atcButton.removeAttribute('disabled') };
}


// swiper page lookbook 2024

// Exposed on window: assets/collection-load-more.js and assets/ajaxinate.min.js
// are plain (non-bundled) scripts that re-bind these same handlers on
// paginated/infinite-scroll product cards, and need to reach them as globals.
window.handleSelectColor = handleSelectColor;
window.handleSelectColorLink = handleSelectColorLink;

document.addEventListener("DOMContentLoaded", () => {
  const colorInputs = document.querySelectorAll(".variant-color-input");
  colorInputs.forEach((input) => {
    input.addEventListener("change", handleSelectColor);
  });

  document.querySelectorAll("a.variant-color-label").forEach((link) => {
    link.addEventListener("click", handleSelectColorLink);
  });

  document.body.addEventListener("click", (evt) => {
    console.log("TARGET", evt.target);
    if (evt.target.classList.contains("direct-atc-plp")) {
      return;
    }

    if (evt.target.classList.contains("trigger-atc-plp")) {
      // Seleccionar elementos con clase "active-atc-plp"
      document.querySelectorAll(".active-atc-plp").forEach((element) => {
        if (evt.target.closest(".item-product") !== element) {
          element.classList.remove("active-atc-plp");
        }
      });

      // Seleccionar elementos con clase "trigger-atc-plp hidden"
      document.querySelectorAll(".item-product:not(.active-atc-plp) .trigger-atc-plp").forEach((element) => {
        element.textContent = "ADD TO CART";
      });

      evt.target.closest(".item-product").classList.toggle("active-atc-plp");
      evt.target.textContent = "Select a Size";
    } else if (
      !evt.target.classList.contains("trigger-atc-plp") &&
      !evt.target.classList.contains("add-to-cart-plp") &&
      document.querySelector(".active-atc-plp")
    ) {
      // Seleccionar elementos con clase "active-atc-plp"
      document.querySelectorAll(".active-atc-plp").forEach((element) => {
        element.classList.remove("active-atc-plp");
      });

      // Seleccionar elementos con clase "trigger-atc-plp hidden"
      document.querySelectorAll(".trigger-atc-plp").forEach((element) => {
        element.textContent = "ADD TO CART";
      });

      // Seleccionar elementos con clase "add-to-cart-plp active"
      document.querySelectorAll(".add-to-cart-plp.active").forEach((element) => {
        element.classList.remove("active");
      });
    } else if (evt.target.classList.contains("add-to-cart-plp")) {
      evt.target.classList.add("active");
    }
  });

  /* MODAL INFO - MODEL PDP */

  const modalModelPdp = () => {
    const modalSign = document.querySelector(".style-with-signs");
    const modalSigns = document.querySelectorAll(".style-with-signs .item__sign");
    if (modalSign) {
      modalSigns.forEach((item) => {
        item.addEventListener("click", (e) => {
          const currentElement = e.target;
          currentElement.classList.add('active');
          showProductCard(currentElement, true);
        });
      });
    }
  }


  const showProductCard = (currentElement, show) => {
    const card = currentElement.closest('.item').querySelector('.card');
    const image_card = currentElement.closest('.images').querySelector('.product-image-pdp').closest('a');
    if (show) {
      card.classList.remove('hidden');
      card.focus();
      document.querySelector('.style-with-signs .overlay').classList.remove('hidden');
    }
    card.addEventListener('blur', (e) => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        card.classList.add('hidden');
        currentElement.classList.remove('active');
        document.querySelector('.style-with-signs .overlay').classList.add('hidden');
      } else {
        card.focus();
      }
    });
  }

  modalModelPdp();

  // sitelock
  initSitelock(document.querySelector('.js-header-sitelock'));

  // page lookbook 2024
  initLookBook24();

  // countCart
  const idCartCount = document.getElementById('cart-item-count');
  if(idCartCount) {
    window.onclick = ({target}) => {
      const ATCButtonsQuery = '#add-to-cart-plp, #pdpn-item-submit, .quantity-button-reduce, .quantity-button-add, .atc-upsell-product, .direct-atc-plp'
      const addToCartLinks  = document.querySelectorAll(ATCButtonsQuery);

      addToCartLinks.forEach(function(addToCartLink){
        if(target.contains(addToCartLink)) {
          setTimeout(() => {
            updateNumberCartCount(idCartCount)
          }, 500);
        }
      });
    }

    setTimeout(() => {
      updateNumberCartCount(idCartCount)
    }, 500);
  }

});

window.handleSelectColor = handleSelectColor

